import { setConversationsFetchConfig } from '@homeexchange/conversations';
import { setUserProfileFetchConfig } from '@homeexchange/user-profile';
import { HeFetch } from '@homeexchange/he-fetch';
import i18n from '../i18n';
import { getDynamicUrl } from '../middleware/lokaliseUrlMiddleware';
var heFetch;
export var setHeFetchConfig = function () {
    var heFetchOptions = {
        headers: {
            he_web_version: process.env.VERSION,
            'Accept-Language': i18n.language
        }
    };
    var dynamicBffUrl = getDynamicUrl(process.env.URL_BFF);
    heFetch = new HeFetch(dynamicBffUrl, heFetchOptions);
    setConversationsFetchConfig(dynamicBffUrl, heFetchOptions);
    setUserProfileFetchConfig(dynamicBffUrl, heFetchOptions);
};
export { heFetch };
